import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';

@Component({
    selector: 'dialog5-template',
    templateUrl: 'dialog5-template.html',
    styleUrls: ['dialog5-template.scss']
})
export class Dialog5Template implements OnInit {
    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<Dialog5Template>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,

    ) {
        if(data){
            this.header = data;
        }
    }

    ngOnInit() {
   
    }
  
}
